import { render, staticRenderFns } from "./expired_stock.vue?vue&type=template&id=0495c773&"
import script from "./expired_stock.vue?vue&type=script&lang=js&"
export * from "./expired_stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports